import { Link } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { isEmpty } from "lodash";
import { type ReactNode } from "react";

const URL_REGEX = /(https?:\/\/\S+)/g;

interface Props {
  text: string;
}

/**
 * Renders text with URLs converted to clickable links.
 * URLs open in a new tab with proper security attributes.
 */
export function LinkifiedText(props: Props): ReactNode {
  const { text } = props;
  if (isEmpty(text)) {
    return null;
  }

  const parts = text.split(URL_REGEX);

  const elements: ReactNode[] = parts.map((part, index) => {
    if (URL_REGEX.test(part)) {
      // Reset regex lastIndex since we're reusing it
      URL_REGEX.lastIndex = 0;
      const key = `${part}-${index}`;
      return (
        <Link
          key={key}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ wordBreak: "break-all" }}
        >
          {part}
        </Link>
      );
    }

    return part;
  });

  return <Text sx={{ whiteSpace: "pre-wrap" }}>{elements}</Text>;
}
